<div
	class="base-card"
	[ngClass]="{ 'base-card--shadow': withShadow }"
	[ngStyle]="{ backgroundColor: backgroundColor }">
	<ng-content></ng-content>
</div>
